module.exports = __webpack_public_path__ + "img/bah.905382e9.svg";